import store from '@/stores'

export default async (to, from, next) => {
  const user = store.state.authStore.userData
  if (!user) return next()

  const latestDeals = await store.dispatch('feathers/getRecentDeals', user.id)

  return latestDeals.length < 3
    ? next()
    : next({ name: 'LenderResults' })
}
